/* Lucky Pup framed-print browser personalisation v2. Shared Shopify media stays dog-neutral. */
(function () {
  'use strict';

  var HANDLE = 'personalised-dog-portrait-print';
  var PREVIEW_VERSION = 'framed-print-v3-full-replacement';
  var PASS_KEYS = ['collection', 'breed', 'colouring', 'name', 'custom', 'dog', 'expires', 'signature'];
  var COLOURS = {
    White: '#ffffff',
    Cream: '#f2e6ca',
    Grey: '#d3d3d3',
    'Light Pink': '#f3ccd8',
    'Light Blue': '#c9ddec'
  };
  var objectUrls = [];
  var renderedUrls = new Map();
  var activeProfile = null;
  var galleryRefreshTimer = null;

  function signedProfile() {
    var params = new URLSearchParams(location.search);
    var stored = null;
    try { stored = JSON.parse(localStorage.getItem('lpPetProfile') || 'null'); } catch (_) {}
    var name = String(params.get('name') || (stored && stored.name) || '').trim().slice(0, 18);
    var previewUrl = stored && stored.previewUrl;
    if (params.get('custom') === '1' && params.get('dog') && params.get('expires') && params.get('signature')) {
      previewUrl = 'https://lp-personalisation-render-79f43f75.azurewebsites.net/api/custom-dogs/' + encodeURIComponent(params.get('dog')) + '?expires=' + encodeURIComponent(params.get('expires')) + '&signature=' + encodeURIComponent(params.get('signature'));
    }
    return name && previewUrl ? { name: name, previewUrl: previewUrl, params: params } : null;
  }

  function preserveDogContext(params) {
    document.querySelectorAll('a[href*="/products/' + HANDLE + '"]').forEach(function (link) {
      var url = new URL(link.href, location.origin);
      PASS_KEYS.forEach(function (key) {
        var value = params.get(key);
        if (value) url.searchParams.set(key, value);
      });
      link.href = url.pathname + url.search + url.hash;
    });
    if (location.pathname === '/products/' + HANDLE && !history.__lpFramedContextGuard) {
      var replaceState = history.replaceState.bind(history);
      var pushState = history.pushState.bind(history);
      var withContext = function (value) {
        if (!value) return value;
        var url = new URL(String(value), location.origin);
        if (url.pathname !== '/products/' + HANDLE) return value;
        PASS_KEYS.forEach(function (key) {
          var contextValue = params.get(key);
          if (contextValue) url.searchParams.set(key, contextValue);
        });
        return url.pathname + url.search + url.hash;
      };
      history.replaceState = function (state, title, url) { return replaceState(state, title, withContext(url)); };
      history.pushState = function (state, title, url) { return pushState(state, title, withContext(url)); };
      history.__lpFramedContextGuard = true;
    }
  }

  function fullSizeUrl(value) {
    var url = new URL(value, location.origin);
    url.searchParams.delete('width');
    url.searchParams.set('width', '1200');
    return url.href;
  }

  async function bitmap(url) {
    var response = await fetch(url, { mode: 'cors', cache: 'force-cache' });
    if (!response.ok) throw new Error('Image fetch failed: ' + response.status);
    return createImageBitmap(await response.blob());
  }

  function alphaBounds(image) {
    var canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    var context = canvas.getContext('2d', { willReadFrequently: true });
    context.drawImage(image, 0, 0);
    var data = context.getImageData(0, 0, canvas.width, canvas.height).data;
    var left = canvas.width, top = canvas.height, right = -1, bottom = -1;
    for (var y = 0; y < canvas.height; y += 1) {
      for (var x = 0; x < canvas.width; x += 1) {
        if (data[(y * canvas.width + x) * 4 + 3] > 8) {
          if (x < left) left = x;
          if (x > right) right = x;
          if (y < top) top = y;
          if (y > bottom) bottom = y;
        }
      }
    }
    return right >= left && bottom >= top
      ? { x: left, y: top, width: right - left + 1, height: bottom - top + 1 }
      : { x: 0, y: 0, width: image.width, height: image.height };
  }

  function fittedFont(context, name, maximumWidth) {
    var size = 54;
    while (size > 20) {
      context.font = '700 ' + size + 'px "DM Serif Display", Georgia, serif';
      if (context.measureText(name).width <= maximumWidth) break;
      size -= 1;
    }
    return size;
  }

  function buildArtwork(dog, bounds, name, colour) {
    var canvas = document.createElement('canvas');
    canvas.width = 848;
    canvas.height = 1200;
    var context = canvas.getContext('2d');
    context.fillStyle = colour;
    context.fillRect(0, 0, canvas.width, canvas.height);

    var maximumWidth = canvas.width * 0.57;
    var maximumHeight = canvas.height * 0.52;
    var scale = Math.min(maximumWidth / bounds.width, maximumHeight / bounds.height);
    var width = bounds.width * scale;
    var height = bounds.height * scale;
    var left = canvas.width * 0.5 - width / 2;
    var top = canvas.height * 0.43 - height / 2;
    context.drawImage(dog, bounds.x, bounds.y, bounds.width, bounds.height, left, top, width, height);

    var fontSize = fittedFont(context, name, canvas.width * 0.76);
    context.font = '700 ' + fontSize + 'px "DM Serif Display", Georgia, serif';
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.lineJoin = 'round';
    context.lineWidth = 1.2;
    context.strokeStyle = colour;
    context.fillStyle = '#173f34';
    context.strokeText(name, canvas.width * 0.5, canvas.height * 0.79);
    context.fillText(name, canvas.width * 0.5, canvas.height * 0.79);
    return canvas;
  }

  function affine(source, target) {
    var x0 = source[0][0], y0 = source[0][1], x1 = source[1][0], y1 = source[1][1], x2 = source[2][0], y2 = source[2][1];
    var X0 = target[0][0], Y0 = target[0][1], X1 = target[1][0], Y1 = target[1][1], X2 = target[2][0], Y2 = target[2][1];
    var determinant = x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1);
    return {
      a: (X0 * (y1 - y2) + X1 * (y2 - y0) + X2 * (y0 - y1)) / determinant,
      c: (X0 * (x2 - x1) + X1 * (x0 - x2) + X2 * (x1 - x0)) / determinant,
      e: (X0 * (x1 * y2 - x2 * y1) + X1 * (x2 * y0 - x0 * y2) + X2 * (x0 * y1 - x1 * y0)) / determinant,
      b: (Y0 * (y1 - y2) + Y1 * (y2 - y0) + Y2 * (y0 - y1)) / determinant,
      d: (Y0 * (x2 - x1) + Y1 * (x0 - x2) + Y2 * (x1 - x0)) / determinant,
      f: (Y0 * (x1 * y2 - x2 * y1) + Y1 * (x2 * y0 - x0 * y2) + Y2 * (x0 * y1 - x1 * y0)) / determinant
    };
  }

  function drawTriangle(context, artwork, source, target) {
    var transform = affine(source, target);
    context.save();
    context.beginPath();
    context.moveTo(target[0][0], target[0][1]);
    context.lineTo(target[1][0], target[1][1]);
    context.lineTo(target[2][0], target[2][1]);
    context.closePath();
    context.clip();
    context.setTransform(transform.a, transform.b, transform.c, transform.d, transform.e, transform.f);
    context.drawImage(artwork, 0, 0);
    context.restore();
  }

  function sceneCanvas(base, artwork, title) {
    if (/Finished artwork/i.test(title)) return artwork;
    var canvas = document.createElement('canvas');
    canvas.width = 1200;
    canvas.height = 1200;
    var context = canvas.getContext('2d');
    context.drawImage(base, 0, 0, 1200, 1200);
    if (/room lifestyle/i.test(title)) {
      var sourceWidth = artwork.width, sourceHeight = artwork.height;
      drawTriangle(context, artwork, [[0, 0], [sourceWidth, 0], [sourceWidth, sourceHeight]], [[455, 180], [780, 151], [806, 779]]);
      drawTriangle(context, artwork, [[0, 0], [sourceWidth, sourceHeight], [0, sourceHeight]], [[455, 180], [806, 779], [473, 803]]);
    } else {
      // Every supplied front-on photograph uses the same complete A-series print aperture.
      // Replacing the whole aperture prevents saved UAT artwork from showing underneath.
      context.drawImage(artwork, 316, 198, 568, 804);
    }
    return canvas;
  }

  function blobUrl(canvas) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (!blob) return reject(new Error('Canvas export failed.'));
        var url = URL.createObjectURL(blob);
        objectUrls.push(url);
        resolve(url);
      }, 'image/webp', 0.92);
    });
  }

  function parsedAlt(alt) {
    var value = String(alt || '').trim();
    var parts = value.split(/\s+(?:–|-)\s+/);
    if (parts.length < 3 || !/^Personalised dog(?: portrait)? print$/i.test(parts[0])) return null;
    var colourName = Object.keys(COLOURS).find(function (name) {
      return name.toLowerCase() === String(parts[1]).toLowerCase();
    });
    if (!colourName || !parts[2]) return null;
    return { colourName: colourName, title: parts.slice(2).join(' – ') };
  }

  function applyRenderedImage(image) {
    var originalAlt = image.dataset.lpFramedAlt || image.alt;
    var parsed = parsedAlt(originalAlt);
    var url = renderedUrls.get(originalAlt);
    if (!parsed || !url || !activeProfile) return false;
    image.dataset.lpFramedAlt = originalAlt;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = url;
    image.alt = activeProfile.name + ' personalised dog portrait print – ' + parsed.colourName + ' – ' + parsed.title;
    image.dataset.lpFramedReady = '1';
    return true;
  }

  function selectedColour() {
    var checked = Array.prototype.find.call(document.querySelectorAll('input[type="radio"]:checked'), function (input) {
      return String(input.name || '').trim().indexOf('Background colour') === 0;
    });
    return checked && COLOURS[checked.value] ? checked.value : null;
  }

  function filterItemByColour(item, colourName) {
    var image = item.matches && item.matches('img') ? item : item.querySelector && item.querySelector('img');
    var parsed = image && parsedAlt(image.dataset.lpFramedAlt || image.alt);
    if (!parsed) return;
    item.hidden = parsed.colourName !== colourName;
  }

  function refreshVariantGallery() {
    galleryRefreshTimer = null;
    var colourName = selectedColour();
    var gallery = document.querySelector('media-gallery');
    if (!colourName || !gallery) return;

    gallery.querySelectorAll('.product__media-list > .product__media-item, .thumbnail-list > .thumbnail-list__item').forEach(function (item) {
      filterItemByColour(item, colourName);
    });
    document.querySelectorAll('product-modal .product-media-modal__content > img').forEach(function (image) {
      filterItemByColour(image, colourName);
    });

    var active = gallery.querySelector('.product__media-item.is-active:not([hidden])');
    if (!active) {
      var first = gallery.querySelector('.product__media-item:not([hidden])');
      if (first && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(first.dataset.mediaId, true);
    }
    gallery.querySelectorAll('slider-component').forEach(function (slider) {
      if (typeof slider.resetPages === 'function') slider.resetPages();
    });
    document.documentElement.dataset.lpFramedGalleryColour = colourName;
  }

  function scheduleVariantGalleryRefresh() {
    if (galleryRefreshTimer) clearTimeout(galleryRefreshTimer);
    galleryRefreshTimer = setTimeout(refreshVariantGallery, 0);
  }

  function applyRenderedDescendants(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches('img')) applyRenderedImage(node);
    if (node.querySelectorAll) node.querySelectorAll('img').forEach(applyRenderedImage);
  }

  function installProductGalleryGuard() {
    if (window.__lpFramedPrintGalleryGuardInstalled) return;
    window.__lpFramedPrintGalleryGuardInstalled = true;
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (input && input.matches && input.matches('input[type="radio"]')) {
        setTimeout(scheduleVariantGalleryRefresh, 0);
        setTimeout(scheduleVariantGalleryRefresh, 180);
      }
    }, true);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(applyRenderedDescendants);
      });
      scheduleVariantGalleryRefresh();
    }).observe(document.body, { childList: true, subtree: true });
  }

  async function personaliseProduct(profile, dog, bounds) {
    activeProfile = profile;
    installProductGalleryGuard();
    var images = Array.prototype.slice.call(document.images).filter(function (image) { return parsedAlt(image.alt); });
    var groups = new Map();
    images.forEach(function (image) {
      var originalAlt = image.dataset.lpFramedAlt || image.alt;
      image.dataset.lpFramedAlt = originalAlt;
      if (!groups.has(originalAlt)) groups.set(originalAlt, []);
      groups.get(originalAlt).push(image);
    });
    var artworkByColour = new Map();
    Object.keys(COLOURS).forEach(function (colourName) {
      artworkByColour.set(colourName, buildArtwork(dog, bounds, profile.name, COLOURS[colourName]));
    });
    var entries = Array.from(groups.entries());
    if (!entries.length) throw new Error('No framed-print product images matched the live media contract.');
    for (var offset = 0; offset < entries.length; offset += 3) {
      await Promise.all(entries.slice(offset, offset + 3).map(async function (entry) {
        var originalAlt = entry[0], group = entry[1], parsed = parsedAlt(originalAlt);
        var first = group[0];
        var source = first.dataset.lpFramedSource || fullSizeUrl(first.currentSrc || first.src);
        group.forEach(function (image) { image.dataset.lpFramedSource = source; });
        var base = /Finished artwork/i.test(parsed.title) ? null : await bitmap(source);
        var url = await blobUrl(sceneCanvas(base, artworkByColour.get(parsed.colourName), parsed.title));
        renderedUrls.set(originalAlt, url);
        group.forEach(applyRenderedImage);
      }));
    }
    document.querySelectorAll('img').forEach(applyRenderedImage);
    refreshVariantGallery();
    document.documentElement.dataset.lpFramedPrintReady = '1';
    document.documentElement.dataset.lpFramedPrintVersion = PREVIEW_VERSION;
  }

  async function personaliseCollectionCard(profile, dog, bounds) {
    var productLink = document.querySelector('#product-grid a[href*="/products/' + HANDLE + '"]');
    if (!productLink) return;
    var card = productLink.closest('.grid__item') || productLink.closest('.card-wrapper');
    var image = card && card.querySelector('.card__media img');
    if (!image) return;
    var source = fullSizeUrl(image.currentSrc || image.src);
    var base = await bitmap(source);
    var artwork = buildArtwork(dog, bounds, profile.name, COLOURS.White);
    var url = await blobUrl(sceneCanvas(base, artwork, parsedAlt(image.alt)?.title || 'Black wood frame'));
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = url;
    image.alt = profile.name + ' personalised dog portrait print';
    card.dataset.lpFramedPrintReady = '1';
  }

  async function start() {
    if (window.__lpFramedPrintPersonalisationStarted) return;
    var onProduct = location.pathname === '/products/' + HANDLE;
    var onCollection = location.pathname === '/collections/personalised-dog-prints';
    if (!onProduct && !onCollection) return;
    var profile = signedProfile();
    if (!profile) return;
    window.__lpFramedPrintPersonalisationStarted = true;
    preserveDogContext(profile.params);
    await document.fonts.ready.catch(function () {});
    var dog = await bitmap(profile.previewUrl);
    var bounds = alphaBounds(dog);
    if (onProduct) await personaliseProduct(profile, dog, bounds);
    if (onCollection) await personaliseCollectionCard(profile, dog, bounds);
  }

  function begin() {
    start().catch(function (error) {
      document.documentElement.dataset.lpFramedPrintError = '1';
      console.error('[Lucky Pup framed print]', error);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', begin, { once: true });
  else begin();
  addEventListener('pagehide', function () { objectUrls.forEach(URL.revokeObjectURL); }, { once: true });
})();
